const recaptchaKey = process.env['NX_RECAPTCHA_KEY'];

export const getRecaptchaToken = () =>
  new Promise<string>((resolve) => {
    (window as any).grecaptcha.enterprise.ready(() => {
      (window as any).grecaptcha.enterprise
        .execute(recaptchaKey, {
          action: 'validate_email',
        })
        .then((token: string) => resolve(token));
    });
  });
